import FormCodeInput from './FormCodeInput';
export default FormCodeInput;